(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/views/mybets/betrow.js') >= 0) return;  svs.modules.push('/modules/bingo/views/mybets/betrow.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.bingo=_svs.bingo||{};
_svs.bingo.templates=_svs.bingo.templates||{};
svs.bingo.templates.betrow = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"list-group-item-fluid\">\n    <div class=\"bold f-300 fc-navigation-500\">"
    + alias3(((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":2,"column":46},"end":{"line":2,"column":61}}}) : helper)))
    + "</div>\n    <div class=\"f-100\"></div>\n</div>\n<div class=\"list-group-item-fixed align-middle\">\n    <strong class=\"f-300\">"
    + alias3((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"betAmount") : depth0),{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":6,"column":26},"end":{"line":6,"column":54}}}))
    + "</strong> kr\n</div>";
},"useData":true});
Handlebars.partials['svs-bingo-betrow'] = svs.bingo.templates.betrow;
})(svs, Handlebars);


 })(window);